import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const fetchStatus = createAsyncThunk("status/fetchStatus", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "status/allStatus", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

  });
  const status = await response.json();
  return status;
});

export const getActiveStatus = createAsyncThunk("status/getActive", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "status/getActive", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

  });
  const status = await response.json();
  return status;
});

export const statusChangerEtat = createAsyncThunk("status/changerEtat", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "status/changerEtat/" + id, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const status = await response.status;
  return status;
});

export const statusGetById = createAsyncThunk("status/statusGetById", async (id1) => {
  const  id  = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "status/getStatus", {
    method: 'POST',
    headers: {
      'id':id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  
  });
  const status = await response.json();
  return status;
});

export const statusDeleted = createAsyncThunk("status/deleteStatus", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "status/deleteStatus/"+action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  });
  const rootBase = await response.json();
  return rootBase;
});
const statusReduce = createSlice({
  name: "status",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    statusAdded(state, action) {
      fetch(Configuration.BACK_BASEURL + "status/addStatus", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    },
    statusUpdated(state, action) {
      fetch(Configuration.BACK_BASEURL + "status/addStatus", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    },
    /* statusDeleted(state, action) {
      const { id } = action.payload;
      fetch(Configuration.BACK_BASEURL + "status/deleteStatus/"+id, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
      });
    }, */

  },
  extraReducers: {

    [fetchStatus.pending]: (state, action) => {
      state.loading = true;
    },
    [fetchStatus.fulfilled]: (state, action) => {
      state.loading = false;
      state.entities = [...state.entities, ...action.payload];
    },
    [fetchStatus.rejected]: (state, action) => {
      state.loading = false;
    },
    [statusGetById.pending]: (state, action) => {
      state.loading = true;
    },
    [statusGetById.fulfilled]: (state, action) => {
      state.loading = false;
      state.entities = [...state.entities, action.payload];
    },
    [statusGetById.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export const { statusAdded, statusUpdated } = statusReduce.actions;

export default statusReduce.reducer;
